import ReCAPTCHA from 'react-google-recaptcha'

import MediaQuery from 'ui-component-library/components/MediaQuery'

type Props = {
  className?: string
  onChange?: (token: string) => void
  apiKey: string
  lang?: string
}

function ReCaptchaValidation(props: Props) {
  const { apiKey, onChange, className } = props

  return (
    <div className={className}>
      <MediaQuery mobile>
        {({ belowMobile }) => (
          <ReCAPTCHA
            sitekey={apiKey}
            size={!belowMobile ? 'normal' : 'compact'}
            onChange={onChange}
          />
        )}
      </MediaQuery>
    </div>
  )
}
export default ReCaptchaValidation
